module.exports = __webpack_public_path__ + "img/003.7bcfa746.jpg";